import React, { useEffect } from "react";
import styles from  "./index.module.css";
import './weather.css'
function Weather(props) {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://app2.weatherwidget.org/js/?id=ww_8840b0d60e3b9";
    script.async = true;
    document.body.appendChild(script);
    // 引用地址：https://weatherwidget.org/zh/
    return () => {
      document.body.removeChild(script);
    };
  }, []);
  
  return (
    <div  className={styles['weather-container']}>
      <div
        id="ww_8840b0d60e3b9"
        v="1.3"
        loc="id"
        a='{"t":"horizontal","lang":"zh","sl_lpl":1,"ids":["wl3562"],"font":"Arial","sl_ics":"one_a","sl_sot":"celsius","cl_bkg":"#FFFFFF00","cl_font":"rgba(255,255,255,1)","cl_cloud":"#d4d4d4","cl_persp":"#2196F3","cl_sun":"#FFC107","cl_moon":"#FFC107","cl_thund":"#FF5722","el_whr":3}'
      >
        <a
          href="https://weatherwidget.org/"
          id="ww_8840b0d60e3b9_u"
          target="_blank"
          rel="noopener noreferrer"
        >
          Widget weather
        </a>
      </div>
      <div className={styles['weather-location']} >
       
      </div>
    </div>
  );
}

export default Weather;
